<template>
  <modal
    size="lg"
    v-bind="$attrs"
    @close="close"
  >
    <div class="py-3 px-md-5">
      <h5 class="text-center mb-4">
        {{ $t('manage-master-data.work-locations.create-work-location') }}
      </h5>

      <div class="form-group">
        <label>
          <small class="font-weight-bold">{{ $t('manage-master-data.work-locations.work-location-name') }}</small>
        </label>
        <input
          v-model="form.name"
          type="text"
          class="form-control"
        >
        <div
          v-if="!$v.form.name.required && $v.form.name.$error"
          class="text-danger"
        >
          <small>
            {{
              $t(
                'manage-master-data.work-locations.error.required',
                { name: $t('manage-master-data.work-locations.work-location-name') }
              )
            }}
          </small>
        </div>
        <div
          v-if="Object.keys(error).length"
          class="text-danger"
        >
          <small>
            {{ $i18n.locale === 'en' ? error.messageEng : error.messageIdn }}
          </small>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>
              <small class="font-weight-bold">Latitude</small>
            </label>
            <input
              v-model="form.latitude"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>
              <small class="font-weight-bold">Longitude</small>
            </label>
            <input
              v-model="form.longitude"
              type="text"
              class="form-control"
            >
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>
              <small class="font-weight-bold">{{ $t('manage-master-data.work-locations.is-shown') }}</small>
            </label>
            <div>
              <toggle-button
                v-model="form.isShow"
                color="#18B2BD"
                sync
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>
              <small class="font-weight-bold">{{ $t('manage-master-data.work-locations.is-organization') }}</small>
            </label>
            <div>
              <toggle-button
                v-model="form.isOrganization"
                color="#18B2BD"
                sync
              />
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-3">
        <button
          class="btn btn-info btn-sm p-2 font-weight-bold"
          :disabled="isSaving"
          @click="save"
        >
          <div
            v-if="isSaving"
            class="spinner-border spinner-border-sm text-light"
          />
          <div v-else>
            {{ $t('manage-master-data.save') }}
          </div>
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { ToggleButton } from 'vue-js-toggle-button'
import api from '@/utils/Api'
import Modal from '@/components/Modal'

const INITIAL_FORM = {
  name: '',
  latitude: '',
  longitude: '',
  isShow: false,
  isOrganization: false
}

export default {
  components: {
    ToggleButton,
    Modal
  },

  data: () => ({
    form: { ...INITIAL_FORM },
    isSaving: false,
    error: {}
  }),

  methods: {
    async save () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.isSaving = true
      try {
        await api.workLocations.save(this.form)
        this.$emit('saved')
        this.error = {}
      } catch ({ response }) {
        this.error = response.data.message
      } finally {
        this.isSaving = false
      }
    },
    close () {
      this.form = { ...INITIAL_FORM }
      this.$emit('close')
      this.error = {}
    }
  },

  validations: {
    form: {
      name: {
        required
      }
    }
  }
}
</script>
